import { render } from "./Aceitos.vue?vue&type=template&id=7b2825ce&scoped=true"
import script from "./Aceitos.vue?vue&type=script&lang=js"
export * from "./Aceitos.vue?vue&type=script&lang=js"

import "./Aceitos.vue?vue&type=style&index=0&id=7b2825ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b2825ce"]])

export default __exports__